
import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAlertObsoleteunreadCountSlice = createApi(`GetAlertObsoleteunreadCountSlice`,"GET");

const GetAlertObsoleteunreadCountSlice = createSlice({
  name: 'GetAlertObsoleteunreadCountSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlertObsoleteunreadCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlertObsoleteunreadCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAlertObsoleteunreadCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAlertObsoleteunreadCountSlice.reducer;